import {
  ImageStyle,
  LoaderStyle,
  LoadingText,
  SpinnerStyle,
  ImageContainer
} from './Loader.styles';

import content from './content';
import { useAppSelector } from '@/redux';
import { useTranslation } from '@CS/hooks';
import { Loader as Assets } from '@CS/assets';
import LottieAnimation from '@CS/components/LottieAnimation';
import Spinner from '@CS/assets/Vector/spinner.svg?component';

export type LoaderProps = {
  overlay?: boolean;
  opacity?: number;
  lottie?: boolean;
  image?: boolean;
  color?: string;
  speed?: number;
  width?: number;
};

export const Loader = ({
  color = 'white',
  lottie = true,
  image = false,
  width = 242,
  speed = 2.5
}: LoaderProps) => {
  const { language } = useAppSelector((state) => state.user);

  const label = useTranslation(content);

  const loader = lottie ? (
    language === 'ar' ? (
      <ImageStyle>
        <ImageContainer width={width}>
          <img src={Assets.LogoAR} />
          <LoadingText>{label}</LoadingText>
        </ImageContainer>
      </ImageStyle>
    ) : (
      <ImageStyle>
        <ImageContainer width={width}>
          <LottieAnimation animationData={Assets.Lottie} />
          <LoadingText>{label}</LoadingText>
        </ImageContainer>
      </ImageStyle>
    )
  ) : image ? (
    <ImageStyle>
      <ImageContainer width={width}>
        <img src={Assets.Gif} />
      </ImageContainer>
    </ImageStyle>
  ) : (
    <SpinnerStyle color={color} speed={speed} width={width}>
      <Spinner />
    </SpinnerStyle>
  );

  return <LoaderStyle>{loader}</LoaderStyle>;
};
